export default {
    contact: {
        title : "Kontakte",
        create: "Neuen Kontakt anlegen",
        query: {
            notExists: "Zum Fortfahren bitte einen Kontakt für das ausführende Unternehmen erfassen.",
        },

        remove: {
            refresh: "Anzeige aktualsieren",
            perform: "Kontakte löschen",
            done   : "Die Kontakte wurden gelöscht!",
            confirm: {
                query: "Sollen die Kontakte gelöscht werden?",
                text : "Die Kontakte werden endgültig gelöscht. Diese Aktion kann nicht mehr rückgängig gemacht werden. Mit <b>JA</b> werden die Kontakte gelöscht."
            }
        },

        combine: {
            confirm: {
                query: "Kontakte zusammenfassen?",
                text : "Mit <b>JA<b></b> werden alle Anlagenzuordnungen des linken Kontakts dem rechts angezeigten Kontakt zugeordnet. Der linke Kontakt wird anschließend gelöscht und kann nicht mehr verwendet werden."
            }
        },

        error: {

        } ,

        dissolve: {
            tooltip: "Kontakt entfernen",
            query  : "Kontakt entfernen?",
            text   : "Mit <b>JA</b> wird der Kontakt <b>{0}</b> aus der Anlage <b>{1}</b> des Kunden <b>{2}</b> entfernt. Soll die Löschung der Zuordnung durchgeführt werden?"
        },

        assign: {
            tooltip: "Kontakt zuordnen"
        }
    },
}